export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !isNaN(value);
export const isDate = (value: unknown): value is Date => value instanceof Date;
export const isNonArrayObject = (value: unknown): value is object =>
  typeof value === 'object' && !Array.isArray(value) && value !== null;

export function assertNonNull<T>(value: T | null): asserts value is T {
  if (!isDefined(value)) {
    throw new Error('Data source must be defined');
  }
}

export const isTypeObject = (value: unknown): value is object =>
  typeof value === 'object';

export const isString = (value: unknown): value is string =>
  typeof value === 'string';

export const isDefined = <T>(value: unknown): value is T =>
  value !== undefined && value !== null;
